<div class="container-options">
    <div>
        <mat-checkbox class="tv-blueish-grey-checkbox" (change)="onSelectAllChange($event)">Sélectionner Tout</mat-checkbox>
    </div>

    <div class="tv-ns-custom-horizontal-divider"></div>

    <div class="search-container">
        <div
            class="tv-round-input-extensible-no-label full-width"
            [ngClass]="{ 'fade-in-right': panelOpened, 'fade-out-left': !panelOpened }">
            <mat-form-field>
                <mat-icon matPrefix class="small-icon">search</mat-icon>
                <input matInput [formControl]="searchFormControl" name="search" />
            </mat-form-field>
        </div>
    </div>

    <!-- Category Items -->
    <div *ngIf="!isLoadingItemList" class="checkbox-list tv-custom-scroll-bar">
        <mat-checkbox
            class="tv-blueish-grey-checkbox"
            *ngFor="let item of filteredItemList$ | async; trackBy: trackByItemId"
            [checked]="isOptionSelected(item)"
            (change)="onOptionChange($event, item)">
            {{ item.name }} - ({{ item.id }})
        </mat-checkbox>
    </div>

    <div *ngIf="isSelectionInvalid" class="selection-required-info" role="note">
        <mat-icon class="material-icons-outlined" aria-hidden="true">info</mat-icon>
        <span>{{ data.selectionRequiredMessage }}</span>
    </div>

    <div class="button-edit">
        <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelSelectClick()">Annuler</button>
        <button class="tv-ns-validation-large-button" [disabled]="isSelectionInvalid" (click)="onSaveChosenItemList()">Valider</button>
    </div>
</div>
